import { OmissionBoqStateTypes, OmissionBoqActionTypes } from "./OmissionBoq.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: OmissionBoqStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const OmissionBoqReducer = (
  state: OmissionBoqStateTypes = INITIAL_STATE,
  action: any
): OmissionBoqStateTypes => {
  switch (action.type) {
    case OmissionBoqActionTypes.FETCH_ALL_OMISSION_BOQ:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case OmissionBoqActionTypes.FETCH_ALL_OMISSION_BOQ_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case OmissionBoqActionTypes.FETCH_ALL_OMISSION_BOQ_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case OmissionBoqActionTypes.FETCH_ALL_OMISSION_BOQ_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case OmissionBoqActionTypes.FETCH_ONE_OMISSION_BOQ:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case OmissionBoqActionTypes.FETCH_ONE_OMISSION_BOQ_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case OmissionBoqActionTypes.FETCH_ONE_OMISSION_BOQ_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case OmissionBoqActionTypes.FETCH_ONE_OMISSION_BOQ_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default OmissionBoqReducer;
